export enum AsyncStatus {
  Pending = 'pending',
  Idle = 'idle',
  Fulfilled = 'fulfilled',
  Rejected = 'rejected'
};
